import PropTypes from 'prop-types';

export default PropTypes.shape({
    name: PropTypes.node.isRequired,
    role: PropTypes.node.isRequired,
    accountTitle: PropTypes.node,
    withImage: PropTypes.bool,
}).isRequired;
